import React, {ComponentProps} from 'react'
import {CheckCircleIcon, ExclamationCircleIcon} from '../../components/icons'
import {Flex, Box} from '../../vanilla'
import {alertRecipe} from './styles.css'

export interface Alert extends ComponentProps<typeof Flex> {
  status: 'success' | 'error' | 'warning' | 'info'
  children?: React.ReactNode
}

export const Alert = ({status, children, ...props}: Alert) => {
  const className = alertRecipe({status})

  return (
    <Flex className={className} gap="8px" align="flex-start" {...props}>
      {['error', 'warning', 'info'].includes(status) && <ExclamationCircleIcon color="inherit" flexShrink="0" marginTop="2px" />}
      {['success'].includes(status) && <CheckCircleIcon color="inherit" flexShrink="0" marginTop="2px" />}
      {children && <Box>{children}</Box>}
    </Flex>
  )
}
